<template>
  <div>
    <v-btn :text="text" :color="buttonColor" @click="like()">
      <v-icon :class="getColor" class="mr-2" style="font-size:21px;">
        $vuetify.icons.mdiHeart
      </v-icon>
      <span :class="getColor">{{ transLikeText }}</span>
    </v-btn>
  </div>
</template>
<script>
export default {
  props: {
    buttonColor: {
      type: [String],
      required: false,
      default: '#606770'
    },
    text: {
      type: [Boolean],
      required: false,
      default: true
    },
    number: {
      type: [Boolean],
      required: false,
      default: false
    },
    object: {
      type: [Object],
      required: true,
      default: function() {}
    },
    likeText: {
      type: [String],
      required: false,
      default: 'like'
    }
  },
  computed: {
    transLikeText() {
      if (this.number && this.object.is_liked) {
        return parseInt(this.likeText) + 1
      }
      if (this.likeText == 'like') {
        return this.$t('actions.like')
      }
      return this.likeText
    },
    getColor() {
      if (this.object.is_liked) {
        return 'accent--text'
      }
      return ''
    }
  },
  methods: {
    async like() {
      if (!this.$auth.user) {
        return (this.$store.state.signupDialog = true)
      }
      const data = {
        object_id: this.object.id,
        type: this.object.get_class
      }

      if (this.object.is_liked) {
        this.object.is_liked = false
      } else {
        this.object.is_liked = true
      }

      try {
        const res = await this.$api.like(data)
      } catch (e) {
        this.$toast.error(this.$i18n.t('toast.error'), {
          theme: 'bubble',
          duration: 5000
        })
        if (this.object.is_liked) {
          this.object.is_liked = false
        } else {
          this.object.is_liked = true
        }
      }
    }
  }
}
</script>
